import { ref, type Ref } from "vue";
import type FormCC from "@/interface/FormCC";
import MasterService from "@/service/restfulService/CCOnboardMasterService";

export default function emergencyContactSubmit(
  ccFormValue: Ref<FormCC>,
  prop: any,
  page5Overlay: Ref<boolean>,
  isTimeOut: Ref<boolean>,
  isSessionEnd: Ref<boolean>,
  jumpStep: (value: number, name: string, page: string) => void
): void {
  page5Overlay.value = true;
  const requestModel = {
    dropOffStep: "S6",
    webFormRequestId: ccFormValue.value.webFormRequestId,
    cardId: prop.cardId,
    icNumber: ccFormValue.value.basicInformation.idNo,
    webFormDetails: {
      emergencyContactInfo: {
        title: ccFormValue.value.emergencyContact.title,
        contactName: ccFormValue.value.emergencyContact.relativeName,
        relationship: ccFormValue.value.emergencyContact.relationship,
        contactNoCountryCode: ccFormValue.value.emergencyContact.countryCode,
        contactNo: ccFormValue.value.emergencyContact.mobileNo,
      },
    },
  };
  MasterService.pageSubmit(requestModel, ccFormValue.value.token)
    .then((res) => {
      if (res.status == 200) {
        ccFormValue.value.dropOffStep = 6;
        if (ccFormValue.value.summarySetting.emergencyContactJump == true) {
          ccFormValue.value.summarySetting.emergencyContactJump = false;
          jumpStep(12, "", "5");
          page5Overlay.value = false;
        } else {
          if (
            ccFormValue.value.basicInformation.idType != "1" &&
            ccFormValue.value.basicInformation.profession == "20"
          ) {
            jumpStep(7, "", "5");
            page5Overlay.value = false;
          } else {
            jumpStep(6, "", "5");
            page5Overlay.value = false;
          }
        }
      }
    })
    .catch((e) => {
      if (e.response && e.response.data.code == "WB-401") {
        // EndSession
        isTimeOut.value = false;
        isSessionEnd.value = true;
      }
    });
}
